



















import { defineComponent } from '@vue/composition-api'

import PageView from '@/components/templates/h/jyuyou-yosoku/promo-sales-reduce/PageView.vue'
import SettingImportModal from '@/components/templates/h/SettingImportModal.vue'
import {
  promoSalesReduceExtractCondition,
  promoSalesReduceOutputCondition,
  ColumnLabel,
} from '@/types/entities'
import {
  TemplateFile,
  ResourceType,
  Where,
  WhereOp,
  OrderBy,
  OrderByDirection,
  OrderByNullsOption,
  VUiPPromoSalesReducesCountDocument,
} from '@/types/generated/graphql'
import {
  OUTPUT_COND_DELETE,
  OUTPUT_COND_STORE,
  OUTPUT_EXTRACT_TARGET_DEFAULT,
  EXPORT_FILENAME,
  SELECT_MAX_COUNT,
} from '@/utils/constant'
import importExportHelper from '@/utils/importExportHelper'
import { addDayYMD } from '@/utils/mixin'
import { setWhereValue } from '@/utils/searchConditionDef'
import Toast from '@/utils/toast'

const DEFAULT_OUTPUT_CONST = {
  extractTarget: OUTPUT_EXTRACT_TARGET_DEFAULT,
  storeOutput: [
    OUTPUT_COND_STORE.all,
    OUTPUT_COND_STORE.tana,
    OUTPUT_COND_STORE.tanten,
  ],
  delOutput: [],
}

const DEFAULT_EXTRACT_CONST = {
  validDate: [addDayYMD(1), '2999-12-31'],
}
export default defineComponent({
  components: { PageView, SettingImportModal },
  layout: 'sidebar',
  created() {
    this.helper = new importExportHelper(this)
  },
  data() {
    return {
      defaultDateValue: DEFAULT_EXTRACT_CONST.validDate,
      resourceType: ResourceType.UiPPromoSalesReduce,
      templateFile: TemplateFile.UiPPromoSalesReduce_01,
      extractCondition: {
        validData: DEFAULT_EXTRACT_CONST.validDate,
        storeShelve: [],
        store: [],
        shobunrui: [],
        class: [],
        category: [],
        tanpin: [],
        selectedRadio: '',
      },
      outputCondition: DEFAULT_OUTPUT_CONST,
      outputUseList: [
        {
          outputCondType: 'Store',
          displayItems: [
            OUTPUT_COND_STORE.all,
            OUTPUT_COND_STORE.tana,
            OUTPUT_COND_STORE.tanten,
          ],
          defaultSelected: DEFAULT_OUTPUT_CONST.storeOutput,
          disabledItems: [],
          isTanaPattern: true,
        },
        {
          outputCondType: 'Delete',
          displayItems: [OUTPUT_COND_DELETE.includeDelete],
          defaultSelected: DEFAULT_OUTPUT_CONST.delOutput,
          disabledItems: [],
        },
      ],
      totalCount: null,
      exportSpinner: false,
    }
  },
  methods: {
    changeExtractCondition(cond: promoSalesReduceExtractCondition) {
      console.log('changeExtractCondition', cond)
      this.extractCondition = cond
      this.requestCount()
    },
    changeOutputCondition(cond: promoSalesReduceOutputCondition) {
      console.log('changeOutputCondition', cond)
      this.outputCondition = cond
      this.requestCount()
    },
    async requestCount() {
      this.totalCount = null
      this.exportSpinner = true
      if (this.checkRequired(false)) {
        try {
          const result = await this.$apollo.query({
            query: VUiPPromoSalesReducesCountDocument,
            variables: { where: this._createWhere() },
          })
          const data = result.data.vUiPPromoSalesReduces.totalCount
          this.totalCount = data.toString()
          this.exportSpinner = false
        } catch (e) {
          console.error(e)
          this.exportSpinner = false
          this.totalCount = '-'
        }
      } else {
        this.exportSpinner = false
        this.totalCount = '-'
      }
    },
    requestImport() {
      console.log('requestImport')
      this.$refs.settingImportModal.show()
    },
    async importFileUpload(files: File[]) {
      console.log('importFileUpload', { files })
      this.helper.import({ files: files, resourceType: this.resourceType })
    },
    checkRequired(showToast: boolean) {
      let errMsg = []
      if (
        !this.extractCondition.validData[0] ||
        !this.extractCondition.validData[1] ||
        this.extractCondition.selectedRadio == '' ||
        (this.extractCondition.selectedRadio == 'Tana' &&
          this.extractCondition.storeShelve.length == 0 &&
          this.extractCondition.shobunrui.length == 0 &&
          this.extractCondition.class.length == 0 &&
          this.extractCondition.category.length == 0) ||
        (this.extractCondition.selectedRadio == 'ItemStore' &&
          this.extractCondition.storeShelve.length == 0 &&
          this.extractCondition.store.length == 0 &&
          this.extractCondition.shobunrui.length == 0 &&
          this.extractCondition.tanpin.length == 0)
      ) {
        errMsg.push({
          message: this.$i18n.t('error.requiredItemNotInput'),
        })
      }
      if (this.extractCondition.storeShelveCount > SELECT_MAX_COUNT) {
        errMsg.push({
          message: this.$i18n.t('error.itemInputIsTooMany', {
            item: this.$i18n.t('label.tanaPattern'),
            selected: this.extractCondition.storeShelveCount,
            max: SELECT_MAX_COUNT,
          }),
        })
      }
      if (this.extractCondition.storeCount > SELECT_MAX_COUNT) {
        errMsg.push({
          message: this.$i18n.t('error.itemInputIsTooMany', {
            item: this.$i18n.t('label.store'),
            selected: this.extractCondition.storeCount,
            max: SELECT_MAX_COUNT,
          }),
        })
      }
      if (this.extractCondition.shobunruiCount > SELECT_MAX_COUNT) {
        errMsg.push({
          message: this.$i18n.t('error.itemInputIsTooMany', {
            item: this.$i18n.t('label.shobunrui'),
            selected: this.extractCondition.shobunruiCount,
            max: SELECT_MAX_COUNT,
          }),
        })
      }
      if (this.extractCondition.classCount > SELECT_MAX_COUNT) {
        errMsg.push({
          message: this.$i18n.t('error.itemInputIsTooMany', {
            item: this.$i18n.t('label.class'),
            selected: this.extractCondition.classCount,
            max: SELECT_MAX_COUNT,
          }),
        })
      }
      if (this.extractCondition.categoryCount > SELECT_MAX_COUNT) {
        errMsg.push({
          message: this.$i18n.t('error.itemInputIsTooMany', {
            item: this.$i18n.t('label.category'),
            selected: this.extractCondition.categoryCount,
            max: SELECT_MAX_COUNT,
          }),
        })
      }
      if (this.extractCondition.tanpinCount > SELECT_MAX_COUNT) {
        errMsg.push({
          message: this.$i18n.t('error.itemInputIsTooMany', {
            item: this.$i18n.t('label.tanpin'),
            selected: this.extractCondition.tanpinCount,
            max: SELECT_MAX_COUNT,
          }),
        })
      }
      if (errMsg.length) {
        if (showToast) {
          for (const msg of errMsg) {
            Toast.error(this, msg)
          }
        }
        return false
      }
      return true
    },
    async requestExport() {
      if (this.checkRequired(true)) {
        await this.helper.export({
          query: this._create_query_string(),
          jmespathQuery:
            'data.vUiPPromoSalesReduces.edges[].node | map(&merge(`{"__update": null}`, @), @)',
          templateFile: this.templateFile,
          filenameExport: EXPORT_FILENAME.promo_sales_reduce,
          columnLabelMapping: this._create_column_label_mapping(),
        })
      }
    },
    _create_query_string() {
      const where = this._createWhere()
      const rowQuery = `
query {
  vUiPPromoSalesReduces(
    where: ${this.helper.generateQueryWhereString(where)}
    orderBy: ${this._createOrderByString()}
  ) {
    edges {
      node {
        inactiveFlg
        storeApplyLevel
        storeApplyScope
        vUiMStoreApplyLevel {
          storeApplyScopeName
        }
        itemApplyScope
        vUiMItemApplyLevel {
          itemApplyScopeName
          m2oItem {
            category1
            uiMCategory2 {
              categoryName
            }
            uiMCategory3 {
              categoryName
            }
          }
        }
        startDate
        endDate
        salesReduceBaseInventory
        salesReduceAdjustDays
        minLimitOrderPoint
        configuredFlg
        lastModifiedDatetime
        lastModifiedUserName
      }
    }
  }
}
`
      return this.helper.generateQueryString({
        rowQuery: rowQuery,
        resourceType: this.resourceType,
        where: where,
      })
    },
    _createWhere() {
      const PROMO_SALES_REDUCE_SEARCH_CONDITION: Where[] = [
        { field: ['startDate'], op: WhereOp.Le, value: [''] },
        { field: ['endDateNvl'], op: WhereOp.Ge, value: [''] },
        {
          field: ['vUiMItemApplyLevel/uiMCategory1s/category1Cd'],
          op: WhereOp.In,
          value: [''],
        },
        {
          field: ['vUiMItemApplyLevel/uiMCategory2s/category2Cd'],
          op: WhereOp.In,
          value: [''],
        },
        {
          field: ['vUiMItemApplyLevel/uiMCategory3s/category3Cd'],
          op: WhereOp.In,
          value: [''],
        },
        {
          field: ['vUiMStoreApplyLevel/vUiPAreas/areaCd'],
          op: WhereOp.In,
          value: [''],
        },
        {
          field: ['vUiMItemApplyLevel/m2oItem/saleItemCd'],
          op: WhereOp.In,
          value: [''],
        },
        {
          field: ['vUiMStoreApplyLevel/validStores/storeCd'],
          op: WhereOp.In,
          value: [''],
        },
        { field: ['configuredFlg'], op: WhereOp.In, value: [''] },
        { field: ['storeApplyLevel'], op: WhereOp.In, value: [''] },
        { field: ['inactiveFlg'], op: WhereOp.In, value: [''] },
      ]
      const where = JSON.parse(JSON.stringify(PROMO_SALES_REDUCE_SEARCH_CONDITION))
      const validData = this.extractCondition.validData
      setWhereValue(where, 'startDate', [validData[1]])
      setWhereValue(where, 'endDateNvl', [validData[0]])
      setWhereValue(
        where,
        'vUiMItemApplyLevel/uiMCategory1s/category1Cd',
        this.extractCondition.shobunrui
      )
      setWhereValue(
        where,
        'vUiMItemApplyLevel/uiMCategory2s/category2Cd',
        this.extractCondition.class
      )
      setWhereValue(
        where,
        'vUiMItemApplyLevel/uiMCategory3s/category3Cd',
        this.extractCondition.category
      )
      setWhereValue(
        where,
        'vUiMStoreApplyLevel/vUiPAreas/areaCd',
        this.extractCondition.storeShelve
      )
      setWhereValue(
        where,
        'vUiMStoreApplyLevel/validStores/storeCd',
        this.extractCondition.store
      )
      setWhereValue(
        where,
        'vUiMItemApplyLevel/m2oItem/saleItemCd',
        this.extractCondition.tanpin
      )
      setWhereValue(where, 'configuredFlg', this.outputCondition.extractTarget)
      setWhereValue(where, 'storeApplyLevel', this.outputCondition.storeOutput)
      setWhereValue(where, 'inactiveFlg', [
        '0',
        ...this.outputCondition.delOutput,
      ])
      console.log({ where })
      return where
    },
    _createOrderByString() {
      const orderBy: OrderBy[] = [
        {
          field: 'storeApplyLevel',
          direction: OrderByDirection.Asc,
          nullsOption: OrderByNullsOption.NullsLast,
        },
        {
          field: 'storeApplyScope',
          direction: OrderByDirection.Asc,
          nullsOption: OrderByNullsOption.NullsLast,
        },
        {
          field: 'itemApplyLevel',
          direction: OrderByDirection.Asc,
          nullsOption: OrderByNullsOption.NullsLast,
        },
        {
          field: 'itemApplyScope',
          direction: OrderByDirection.Asc,
          nullsOption: OrderByNullsOption.NullsLast,
        },
      ]
      console.log({ orderBy })
      return this.helper.generateQueryOrderByString(orderBy)
    },
    _create_column_label_mapping() {
      const columnLabelMapping: ColumnLabel[] = [
        {
          from: '__update',
          to: '',
        },
        {
          from: 'inactiveFlg',
          to: '',
        },
        {
          from: 'storeApplyLevel',
          to: '',
        },
        {
          from: 'storeApplyLevelName',
          to: '',
        },
        {
          from: 'storeApplyScope',
          to: '',
        },
        {
          from: 'vUiMStoreApplyLevel.storeApplyScopeName',
          to: '',
        },
        {
          from: 'itemApplyScope',
          to: '',
        },
        {
          from: 'vUiMItemApplyLevel.itemApplyScopeName',
          to: '',
        },
        {
          from: 'vUiMItemApplyLevel.m2oItem.category1',
          to: '',
        },
        {
          from: 'vUiMItemApplyLevel.m2oItem.uiMCategory2.categoryName',
          to: '',
        },
        {
          from: 'vUiMItemApplyLevel.m2oItem.uiMCategory3.categoryName',
          to: '',
        },
        {
          from: 'startDate',
          to: '',
        },
        {
          from: 'endDate',
          to: '',
        },
        {
          from: 'salesReduceBaseInventory',
          to: '',
        },
        {
          from: 'salesReduceAdjustDays',
          to: '',
        },
        {
          from: 'minLimitOrderPoint',
          to: '',
        },
        {
          from: 'configuredFlg',
          to: '',
        },
        {
          from: 'lastModifiedDatetime',
          to: '',
        },
        {
          from: 'lastModifiedUserName',
          to: '',
        },
      ]
      console.log({ columnLabelMapping })
      return columnLabelMapping
    },
  },
})
